export const YANDEX_METRIKA_COUNTER_ID = 97537735;

export const YANDEX_METRIKA_GOALS = Object.freeze({
    registrationSuccess: "registration_success",
    tripCreated: "trip_created",
    aiPlanCreated: "ai_plan_created",
    friendInvited: "friend_invited",
    purchaseComplete: "purchase_complete",
});

const warnedDiagnostics = new Set();

const warnOnce = (key, message, details) => {
    if (warnedDiagnostics.has(key)) return;
    warnedDiagnostics.add(key);
    console.warn(message, details || "");
};

const getYandexMetrika = (operationName) => {
    if (typeof window === "undefined") return null;
    if (typeof window.ym === "function") return window.ym;

    warnOnce(
        `ym-unavailable:${operationName}`,
        `[Яндекс.Метрика] window.ym недоступен, операция «${operationName}» не отправлена.`
    );
    return null;
};

const createDiagnosticCallback = (operationName) => () => {
    if (process.env.NODE_ENV !== "production") {
        console.debug(`[Яндекс.Метрика] Операция «${operationName}» передана счётчику.`);
    }
};

export const trackYandexGoal = (goalName, params) => {
    try {
        if (!goalName) {
            warnOnce("empty-goal", "[Яндекс.Метрика] Не указан идентификатор цели.");
            return false;
        }

        const ym = getYandexMetrika(`reachGoal:${goalName}`);
        if (!ym) return false;

        const goalParams = params && typeof params === "object" ? params : {};
        ym(
            YANDEX_METRIKA_COUNTER_ID,
            "reachGoal",
            goalName,
            goalParams,
            createDiagnosticCallback(`reachGoal:${goalName}`)
        );

        return true;
    } catch (error) {
        // Аналитика не должна влиять на основной пользовательский сценарий.
        console.warn(`[Яндекс.Метрика] Не удалось отправить цель «${goalName}».`, error);
        return false;
    }
};

export const trackYandexPageView = (url, options = {}) => {
    const pageUrl = String(url || "").trim();
    if (!pageUrl) {
        warnOnce("empty-hit-url", "[Яндекс.Метрика] Не указан URL SPA-просмотра.");
        return false;
    }

    try {
        const ym = getYandexMetrika(`hit:${pageUrl}`);
        if (!ym) return false;

        ym(YANDEX_METRIKA_COUNTER_ID, "hit", pageUrl, {
            title: typeof document !== "undefined" ? document.title : "",
            ...options,
            callback: createDiagnosticCallback(`hit:${pageUrl}`),
        });
        return true;
    } catch (error) {
        console.warn(`[Яндекс.Метрика] Не удалось отправить SPA-просмотр «${pageUrl}».`, error);
        return false;
    }
};

export const trackRegistrationSuccess = () =>
    trackYandexGoal(YANDEX_METRIKA_GOALS.registrationSuccess);
